import { StyleSheet } from 'react-native'

export default StyleSheet.create({
    headerStyle: insets => ({
        paddingTop: insets.top,
        height: 60 + insets.top
    })
})
